import Vue from 'vue';
import UIcon from '@/components/redesign/ui/UIcon';

Vue.component('UIcon', UIcon);
